import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav3").addClass("active")
var swiper = new Swiper("#swiper1", {
    observer: true,
    observeParents: true,
    slidesPerView: 3,
    spaceBetween: 10,
    loop:true,
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 1,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 10,
        },
        1367: { //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 10,
        }
    },
    navigation: {
        nextEl: ".li1 .swiper-button-next",
        prevEl: ".li1 .swiper-button-prev",
    },
    pagination: {
        el: '.li1 .swiper-pagination',
        type : 'progressbar',
    },
      on: {
        init: function (swiper) {
            let total = $("#swiper1").attr("data")
            if (total < 10) {
                $('.li1 .total').text("0" + total);
            } else {
                $('.li1 .total').text(total);
            }
            this.emit('transitionEnd');
        },
        transitionEnd: function () {
          var index = this.realIndex + 1;
          if (index < 10) {
            $(".li1 .active").text("0" + index);
          } else {
            $(".li1 .active").text(index);
          }
        }
    }
});
var swiper = new Swiper("#swiper2", {
    observer: true,
    observeParents: true,
    slidesPerView: 3,
    spaceBetween: 10,
    loop:true,
    breakpoints: {
        320: { //当屏幕宽度大于等于320
            slidesPerView: 1,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 10,
        },
        1367: { //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 10,
        }
    },
    navigation: {
        nextEl: ".li2 .swiper-button-next",
        prevEl: ".li2 .swiper-button-prev",
    },
    pagination: {
        el: '.li2 .swiper-pagination',
        type : 'progressbar',
    },
      on: {
        init: function (swiper) {
            let total = $("#swiper2").attr("data")
            if (total < 10) {
                $('.li2 .total').text("0" + total);
            } else {
                $('.li2 .total').text(total);
            }
            this.emit('transitionEnd');
        },
        transitionEnd: function () {
          var index = this.realIndex + 1;
          if (index < 10) {
            $(".li2 .active").text("0" + index);
          } else {
            $(".li2 .active").text(index);
          }
        }
    }
});

var swiper = new Swiper("#swiper3", {
    observer: true,
    observeParents: true,
    slidesPerView: 3,
    spaceBetween: 10,
    loop:true,
    breakpoints: {
        320: { //当屏幕宽度大于等于320
            slidesPerView: 1,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 10,
        },
        1367: { //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 10,
        }
    },
    navigation: {
        nextEl: ".li3 .swiper-button-next",
        prevEl: ".li3 .swiper-button-prev",
    },
    pagination: {
        el: '.li3 .swiper-pagination',
        type : 'progressbar',
    },
      on: {
        init: function (swiper) {
            let total = $("#swiper3").attr("data")
            if (total < 10) {
                $('.li3 .total').text("0" + total);
            } else {
                $('.li3 .total').text(total);
            }
            this.emit('transitionEnd');
        },
        transitionEnd: function () {
          var index = this.realIndex + 1;
          if (index < 10) {
            $(".li3 .active").text("0" + index);
          } else {
            $(".li3 .active").text(index);
          }
        }
    }
});

var swiper = new Swiper("#swiper4", {
    observer: true,
    observeParents: true,
    slidesPerView: 3,
    spaceBetween: 10,
    loop:true,
    breakpoints: {
        320: { //当屏幕宽度大于等于320
            slidesPerView: 1,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 10,
        },
        1367: { //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 10,
        }
    },
    navigation: {
        nextEl: ".li4 .swiper-button-next",
        prevEl: ".li4 .swiper-button-prev",
    },
    pagination: {
        el: '.li4 .swiper-pagination',
        type : 'progressbar',
    },
      on: {
        init: function (swiper) {
            let total = $("#swiper4").attr("data")
            if (total < 10) {
                $('.li4 .total').text("0" + total);
            } else {
                $('.li4 .total').text(total);
            }
            this.emit('transitionEnd');
        },
        transitionEnd: function () {
          var index = this.realIndex + 1;
          if (index < 10) {
            $(".li4 .active").text("0" + index);
          } else {
            $(".li4 .active").text(index);
          }
        }
    }
});
var swiper = new Swiper("#swiper5", {
    observer: true,
    observeParents: true,
    slidesPerView: 3,
    spaceBetween: 10,
    loop:true,
    breakpoints: {
        320: { //当屏幕宽度大于等于320
            slidesPerView: 1,
            },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 10,
        },
        1367: { //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 10,
        }
    },
    navigation: {
        nextEl: ".li5 .swiper-button-next",
        prevEl: ".li5 .swiper-button-prev",
    },
    pagination: {
        el: '.li5 .swiper-pagination',
        type : 'progressbar',
    },
      on: {
        init: function (swiper) {
            let total = $("#swiper5").attr("data")
            if (total < 10) {
                $('.li5 .total').text("0" + total);
            } else {
                $('.li5 .total').text(total);
            }
            this.emit('transitionEnd');
        },
        transitionEnd: function () {
          var index = this.realIndex + 1;
          if (index < 10) {
            $(".li5 .active").text("0" + index);
          } else {
            $(".li5 .active").text(index);
          }
        }
    }
});

